import React from 'react';
import { LogIn } from 'lucide-react';
import { supabase } from '../lib/supabase';

interface Props {
  variant?: 'default' | 'pricing' | 'hero';
  className?: string;
  text?: string;
}

export default function SignUpButton({ variant = 'default', className = '', text = 'Try PostNudge For Free' }: Props) {
  const handleSignUp = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${window.location.origin}/auth/callback`,
        queryParams: {
          access_type: 'offline',
          prompt: 'consent'
        }
      }
    });
  };

  const getButtonStyles = () => {
    switch (variant) {
      case 'pricing':
        return "w-full flex items-center justify-center space-x-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all";
      case 'hero':
        return "flex items-center justify-center space-x-2 px-8 py-4 bg-blue-600 text-white text-lg font-semibold rounded-lg hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl";
      default:
        return "flex items-center space-x-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors";
    }
  };

  return (
    <button
      onClick={handleSignUp}
      className={`${getButtonStyles()} ${className}`}
    >
      <span>{text}</span>
    </button>
  );
}
